import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AxiosRequestConfig } from "axios";
import { LEVEL_1, LEVEL_2, LEVEL_3 } from "common/constants";
import { checkLevel } from "common/rules";
import { useDebounce } from "pages/CreateDeal/newdeal";
import { ComboBoxCurrency } from "pages/PrepareQuoteConatct/L1Flow";
import { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import ReactSelect from "react-select";
import {
  getCountry,
  GetCountryRequestType,
  getPanCardDetails,
  GetPanCardDetailsRequestType,
  getPurpose,
  GetPurposeRequestType,
  getServicePartners,
  GetServicePartnersRequestType,
  PostDealCalcRequestType,
  postDealCalcWithMargin,
} from "service/apis/CreateDealapi";
import {
  getContactDetailsPrepareQuote,
  GetSearchConatctForPrepareQuoteRequestType,
  quoteFromHomePage,
  QuoteFromHomePageRequestType,
  searchContactViaPhone,
} from "service/apis/CreateForexQuotation";
import { toast } from "sonner";
import { formatIndianNumber, handleDownloadViaURL } from "utils";
import { ContactData } from "../dashboard-data";
import { X } from "lucide-react";
import { Img, Spinner } from "components";
import { convertFileToBase64 } from "pages/CreateRemit/documentation";
import { setL2PanCardDetails } from "redux/features/PartnerRegistration";
import { useAppDispatch, useAppSelector } from "redux/hooks";

const tablist = [
  {
    label: "Remittance quotation",
    value: "remit",
    enabled: true,
  },
];

export const educationPaymentModes = [
  {
    label: "Via Transfer",
    value: "20",
  },
  {
    label: "Western Union",
    value: "11",
  },
  {
    label: "PayMyTuition",
    value: "18",
  },
  {
    label: "Flywire",
    value: "9",
  },
  {
    label: "CIBC",
    value: "16",
  },
];
export default function PreparequoteHomepageLevel2() {
  const dispatch = useAppDispatch()
  const [activeTab, setActiveTab] = useState(tablist[0].value);
  const [countryoption, setCountryoption] = useState<
    { label: string; value: string }[]
  >([]);
  const [currencydata, setCurrencydata] = useState<
    { country: string; currency: string }[]
  >([]);
  const [purpose, setPurpose] = useState<{ label: string; value: string }[]>(
    []
  );
  const [pancard, setPancard] = useState<string>("");
  const [panError, setPanError] = useState<string>("");
  const [pancardDetails, setPanCardDetails] = useState<any>(null);
  const [showProfit, setShowProfit] = useState(false);
  const methods = useForm();
  const { setValue, watch, reset } = methods;
  const [isCalcLoading, setIsCalcLoading] = useState(false);
  const [isAddnon, setIsAddnon] = useState(false);

  const avoidCalc = ["1", "3", "4"].includes(watch("purpose"));

  const fetchCountry = () => {
    const payload: AxiosRequestConfig<GetCountryRequestType> = {};
    getCountry(payload)
      .then((res: any) => {
        setCurrencydata(res.data);
        setCountryoption(
          res.data.map((item: any) => {
            return {
              label: item.country,
              value: item.country,
            };
          })
        );
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  const fetchPurpose = () => {
    const payload: AxiosRequestConfig<GetPurposeRequestType> = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      params: {
        product_id: 0,
      },
    };
    getPurpose(payload)
      .then((res) => {
        const filteredPurpose = res.data.filter((item) => item.id !== 13);
        const newPurpose = filteredPurpose?.filter((item) =>
          ["1", "2", "3", "4"].includes(item.id.toString())
        );
        setPurpose(
          newPurpose?.map((item) => {
            return {
              label: item.name,
              value: item.id.toString(),
            };
          })
        );
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const fetchServicePartners = (): void => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const payload: AxiosRequestConfig<GetServicePartnersRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        purpose_id: watch("purpose"),
        currency: watch("currency"),
      },
    };

    getServicePartners(payload)
      .then((res) => {
        if (res.data.length > 0) {
          setValue("service_partner_id", res.data[0].id);
          fetchCalc(pancardDetails?.id);
        } else {
          setValue("service_partner_id", "");
        }

        if (res.data.length < 1) {
          toast.error("Service Partners not available");
        }
      })
      .catch((err) => {
        setValue("service_partner_id", "");
        toast.error(err.response.data.message);
      });
  };

  const fetchCalc = useCallback((customer_id=0): void => {
    if (!watch("amount") || !watch("service_partner_id")) return;
    if (watch("purpose") === "1" && !watch("mode")) {
      return;
    }

    setValue("cal_error", "");

    setIsCalcLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const channel = localStorage.getItem("partner_channel_id");

    const payload: AxiosRequestConfig<PostDealCalcRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        purpose_id: watch("purpose") === "1" ? watch("mode") : watch("purpose"),
        currency: watch("currency"),
        amount: watch("amount"),
        type: "beneficiary_receives",
        created_by: channel?.toString(),
        tcs_type: 1,
        discount: 0,        
        addon_rates: !isAddnon
          ? 0
          : Number(watch("customer_rate")) - watch("fixed_customer_rate"),
        country: watch("country"),
        service_partner_id: watch("service_partner_id"),
        partner_walkin_margin: "0",
        customers_id: customer_id || undefined,
        fx_charges: watch("fxCharges"),
        l1_commission: "0",
        l2_commission: "0",
        l3_commission: "0",
      },
    };

    postDealCalcWithMargin(payload)
      .then((res: any) => {
        setValue("tcs", res?.data.tcs);
        setValue("service_partner_id", res.data.service_partner);
        setValue("foreign_bank_charges", res.data.foreign_bank_charges);
        setValue("set_tt_charges", res.data.tt_charges);
        setValue("service_partner_mode", res.data.service_partner_mode);
        if (res.data.service_partner_mode === "online") {
          setValue("settlement_rates", res.data.settlement_rates);
        } else {
          setValue("settlement_rates", "");
        }
        setValue(
          "cal_total_charges",
          parseFloat(res.data.payable_amount) - parseFloat(res.data.base_amount)
        );
        if (checkLevel(LEVEL_1)) {
          setValue("cal_profit", Number(res.data.profit.l1).toFixed(2));
        }
        if (checkLevel(LEVEL_2)) {
          setValue("cal_profit", Number(res.data.profit.l2).toFixed(2));
        }
        if (checkLevel(LEVEL_3)) {
          setValue("cal_profit", Number(res.data.profit.l3).toFixed(2));
        }
        if (!isAddnon) {
          setValue(
            "customer_rate",
            Number(res.data.fixed_customer_rate)?.toFixed(4)
          );
        }

        // if (state?.partner_id) {
        //   setValue('partner_margin',res.data.commission.l1)
        // }
        setValue(
          "fixed_customer_rate",
          Number(res.data.fixed_customer_rate)?.toFixed(4)
        );
        setValue("cal_amount_inr", res.data.base_amount);
        setValue("cal_gst", res.data.gst);
        setValue("cal_tt_charges", res.data.tt_charges_with_gst);
        setValue("cal_total_payable", res.data.payable_amount);
        setValue(
          "cal_foreign_bank_charges",
          res.data.foreign_bank_charges_with_gst
        );
        setValue(
          "cal_your_rate",
          (
            parseFloat(res?.data?.settlement_rates) +
            (checkLevel(LEVEL_2) ? res?.data?.cumulative_commission.l1 : 0) +
            (checkLevel(LEVEL_3) ? res?.data?.cumulative_commission.l2 : 0)
          )?.toFixed(4)
        );
        setValue(
          "cal_customer_rate",
          parseFloat(res.data.customer_rate)?.toFixed(4)
        );
        setIsCalcLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setValue("cal_error", err.response.data.message);
        setIsCalcLoading(false);
      });
  }, [
    watch("amount"),
    watch("service_partner_id"),
    watch("purpose"),
    watch("mode"),
    watch("customer_rate"),
  ]);

  const buttonState = () => {
    if (watch("purpose") === "2") {
      if (watch("offerletter_checked")) {
        if (!watch("amount") || !watch("country")) {
          return true;
        }
      } else {
        if (!watch("offer_letter_file")) {
          return true;
        }
      }
    } else {
      if (watch("mode")) {
        if (watch("mode") !== "20") {
          if (watch("offerletter_checked")) {
            if (!watch("amount") || !watch("country")) {
              return true;
            }
            return false;
          } else {
            if (!watch("offer_letter_file")) {
              return true;
            }
            return false;
          }
        }
      }
      if (!watch("country")) {
        return true;
      }
      if (!watch("amount")) {
        return true;
      }
      if (watch("cal_error")) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (isAddnon) {
      setIsAddnon(false);
    }
  }, [
    watch("amount"),
    watch("country"),
    watch("mode"),
    watch("purpose"),
    setValue,
  ]);

  useDebounce(
    () => {
      if (watch("country") && watch("purpose")) {
        if (!checkForFetch) {
          return;
        }
        fetchServicePartners();
        if (watch("amount") && watch("service_partner_id")) fetchCalc(pancardDetails?.id);
      }
    },
    600,
    [
      watch("amount"),
      watch("country"),
      watch("mode"),
      watch("purpose"),
      watch("service_partner_id"),
      watch("fxCharges"),
      watch("customer_rate"),
    ]
  );

  useEffect(() => {
    setValue("currency", "USD");
    setValue("purpose", "1");
    setValue("mode", "20");
    setValue('country', 'United States');
    fetchCountry();
    fetchPurpose();
  }, []);

  const checkForFetch = avoidCalc
    ? watch("purpose") === "1"
      ? watch("mode") === "20"
        ? true
        : false
      : true
    : false;

  useEffect(() => {
    // if (watch("purpose") === "2") {
      reset({
        purpose: watch("purpose"),
        mode: "",
        amount: "",
        country: "",
        service_partner_id: "",
        cal_total_charges: "",
        cal_profit: "",
        cal_customer_rate: "",
        cal_gst: "",
        cal_tt_charges: "",
        cal_total_payable: "",
        cal_foreign_bank_charges: "",
        cal_amount_inr: "",
        offerletter_checked: false,
        cal_your_rate: "",
        pancard_no: "",
      });
    // }
    if (watch("purpose") === "1") {
      setValue("currency", "USD");
      setValue("purpose", "1");
      setValue("mode", "20");
      setValue('country', 'United States');
    }
    setValue("fxCharges", "BEN");
    setPancard("");
    setPanCardDetails(null);
    setPanError("");
  }, [watch("purpose")]);

  // fetch Pancard
  const fetchPancard = async (pan_no: string) => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetPanCardDetailsRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        pan_no: pan_no,
      },
    };
    try {
      const res: any = await getPanCardDetails(payload);
      if (res.status === 200) {
        setPanCardDetails(res?.data);
        // fetchCalc();
      }
    } catch (error) {
      console.error("PAN API error:", error);
    }
  };
   const handlePanChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.toUpperCase();

    // Allow only up to 10 characters
    if (value.length > 10) return;

    setPancard(value);
    setValue("pancard_no", value);

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (value.length === 10) {
      if (panRegex.test(value)) {
        setPanError("");      
        fetchPancard(value)  
        dispatch(setL2PanCardDetails(value))      
      } else {
        setPanError("Invalid PAN format (e.g. ABCDE1234F)");
        setPanCardDetails(null);    
        setValue("pancard_no", "");
        setPancard("");   
        dispatch(setL2PanCardDetails(''))  
      }
    } else {
      setPanError("");
      setPanCardDetails(null);
    }
  };
  const [flag,setFlag] = useState<boolean>(false);
  useEffect(() => {
    if(pancard?.length === 10) setFlag(false);
    if(pancard?.length < 10){      
      if(!flag){
        fetchCalc(undefined)
        setFlag(true);
      }
      setValue("pancard_no", "");
      setPanCardDetails(null);
      return;
    }
    if (pancardDetails?.id) {
      fetchCalc(pancardDetails?.id);
    }
  }, [pancard, pancardDetails?.id]);


  // useDebounce(
  //   () => {
  //     fetchCalc();
  //   },
  //   400,
  //   [pancard]
  // );

  useEffect(() => {
    const inputs = document.querySelectorAll('input[type=number]');

    inputs.forEach(input => input.addEventListener('wheel',  (e) => e.preventDefault()));

    return () => {
      inputs.forEach(input => input.removeEventListener('wheel',  (e) => e.preventDefault()));
    };
  }, []);

  return (
    <section className="w-full h-full flex flex-col gap-4">
      <Tabs
        className="flex gap-2 w-full flex-col"
        value={activeTab}
        onValueChange={(value) => {
          setActiveTab(value);
        }}
      >
        <TabsList className=" p-0 w-full ">
          {tablist.map((tab) => (
            <TabsTrigger
              disabled={!tab.enabled}
              key={tab.value}
              value={tab.value}
              className="font-semibold leading-[120%] text-xl text-blue-700 tracking-[4%] border-b rounded-none border-blue-700 w-full"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent
          value="remit"
          className={`w-full h-full flex sm:flex-col ${(watch('purpose')==='2' || (watch('purpose')==='1' && watch('mode')!=='20') )? 'flex-col':""} gap-4`}
        >
          <div className="w-1/2 sm:w-full">
            <div className="grid grid-cols-2 sm:grid-cols-1 gap-4">
              <div className="space-y-2 col-span-2 order-1 ">
                <label
                  htmlFor="purpose"
                  className="text-sm font-normal lg:font-medium leading-[17px] text-[#666666]"
                >
                  Purpose
                </label>
                <ReactSelect
                  className="w-full font-normal lg:font-medium text-sm lg:text-base"
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      zIndex: 0,
                      borderRadius: "0.5rem",
                      height: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
                      boxShadow: "none",
                    }),
                  }}
                  isMulti={false}
                  name="purpose"
                  isSearchable={false}
                  options={purpose}
                  id="purpose"
                  onChange={(e) => {
                    if (e?.value !== "1") {
                      setValue("mode", "");
                    }
                    setValue("purpose", e?.value);
                  }}
                  value={
                    watch("purpose")
                      ? purpose.find((item) => item.value === watch("purpose"))
                      : null
                  }
                  placeholder="Select Purpose"
                />
              </div>
              {(watch("offerletter_checked") ||
                watch("purpose") === "3" ||
                watch("purpose") === "4" ||
                watch("mode") === "20") && (
                <div
                  className={`relative sm:col-span-2 space-y-2 ${
                    watch("purpose") === "1" ? "order-5" : "order-2"
                  }`}
                >
                  <label
                    htmlFor="amount"
                    className="text-sm font-normal lg:font-medium leading-[17px] text-[#666666]"
                  >
                    Currency & Amount
                  </label>
                  <div className="relative w-full rounded-md">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
                      <span className=" font-medium leading-4 -tracking-[1%] p-2.5 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                        {watch("currency") ? watch("currency") : "INR"}
                      </span>
                    </div>
                    <Input
                      type="number"
                      onWheel={(e) => e.currentTarget.blur()} // Prevents scrolling when using number input
                      id="amount"
                      value={watch("amount")}
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue("amount", value);
                      }}
                      name="amount"
                      placeholder="Enter amount"
                      className="m-0 h-12 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
                    />
                  </div>
                </div>
              )}
              {((watch("purpose") === "3" || watch("purpose") === "4") || (watch("purpose") === "1" && watch("mode") === "20")  )  && (
                <div className="space-y-2 sm:col-span-2 order-5">
                  <label
                    htmlFor="fxCharges"
                    className="text-sm font-normal lg:font-medium leading-[17px] text-[#666666]"
                  >
                    FX Charges
                  </label>
                  <RadioGroup
                    className="flex"
                    onValueChange={(value: "BEN" | "OUR") => {
                      setValue("fxCharges", value);
                    }}
                    value={watch("fxCharges")}
                    aria-label="fxCharges"
                    name="fxCharges"
                    id="fxCharges"
                  >
                    <label
                      htmlFor="BEN"
                      className={` ${
                        watch("fxCharges") === "BEN" ? " border-blue-700" : " "
                      } flex items-center rounded-lg border p-3 h-12 space-x-2 w-full`}
                    >
                      <RadioGroupItem
                        value="BEN"
                        id="BEN"
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                      />
                      <p>BEN</p>
                    </label>
                    <label
                      htmlFor="OUR"
                      className={` ${
                        watch("fxCharges") === "OUR" ? "border-blue-700" : ""
                      } flex items-center rounded-lg border p-3 h-12 space-x-2 w-full`}
                    >
                      <RadioGroupItem
                        value="OUR"
                        id="OUR"
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                      />
                      <p>OUR</p>
                    </label>
                  </RadioGroup>
                  {watch("fxCharges") === "BEN" && <small className=''><span className="text-blue-700">&#x24D8;</span> Bank charges will be deducted from the receiver amount</small>}
                </div>
              )}
              {((watch("purpose") === "1" && watch("mode") === "20") || (watch("purpose") === "3" || watch("purpose") === "4")) && (
                <div className="relative space-y-2 sm:col-span-2 order-6">
                  <label
                    htmlFor="customer_rate"
                    className="text-sm font-medium leading-[17px] text-[#666666]"
                  >
                    Enter the customer rate
                  </label>
                  <div className="relative w-full rounded-md">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
                      <span className=" font-medium leading-4 -tracking-[1%] p-2.5 rounded-md bg-[#E1EBFC] text-blue-700 sm:text-sm">
                        INR
                      </span>
                    </div>
                    <Input
                      type="number"
                      onWheel={(e) => e.currentTarget.blur()} // Prevents scrolling when using number input
                      id="customer_rate"
                      name="customer_rate"
                      placeholder="customer rate"
                      value={watch("customer_rate")}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value) {
                          setIsAddnon(true);
                        }
                        setValue("customer_rate", value);
                      }}
                      className="m-0 h-12 max-w-[340px] pl-[70px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
                    />
                  </div>
                </div>
              )}
              {(watch("offerletter_checked") ||
                watch("purpose") === "3" ||
                watch("purpose") === "4" ||
                watch("mode") === "20") && (
                <div
                  className={`space-y-2 sm:col-span-2 ${
                    watch("purpose") === "1" ? "order-2" : "order-1"
                  }`}
                >
                  <label
                    htmlFor="country"
                    className="text-sm font-medium leading-[17px] text-[#666666]"
                  >
                    Country
                  </label>
                  <ReactSelect
                    className="w-full "
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        zIndex: 0,
                        borderRadius: "0.5rem",
                        height: "3rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
                        boxShadow: "none",
                        fontSize: "14px",
                        fontWeight: '400'
                      }),
                    }}
                    isMulti={false}
                    options={countryoption}
                    name="country"
                    id="country"
                    onChange={(e) => {
                      const selectedCountry = e?.value;
                      setValue("country", selectedCountry || "");
                      const selectedCurrency = currencydata.find(
                        (item: any) => item.country === selectedCountry
                      )?.currency;
                      if (selectedCurrency) {
                        setValue("currency", selectedCurrency || "");
                      }
                    }}
                    value={
                      watch("country")
                        ? countryoption.find(
                            (item) => item.value === watch("country")
                          )
                        : null
                    }
                    placeholder="Select Country"
                  />
                </div>
              )}
              <div className="space-y-2 order-6 sm:col-span-2">
                <label
                  htmlFor="pancard_no"
                  className="text-sm font-normal lg:font-medium leading-[17px] text-[#666666]"
                >
                  Enter Pancard {"(optional)"}
                </label>
                <div className="relative w-full rounded-md">
                  <Input
                    type="text"
                    id="pancard_no"
                    name="pancard_no"
                    placeholder="Pancard Number"
                    value={pancard}
                    onChange={handlePanChange}
                    className="m-0 h-12 text-sm font-normal lg:font-medium max-w-[340px] border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg uppercase"
                  />
                  {panError && (
                    <p className="text-red-500 text-xs mt-1">{panError}</p>
                  )}
                </div>
              </div>
              {watch("purpose") === "1" && (
                <div className="space-y-2 col-span-2 order-1">
                  <label
                    htmlFor="mode"
                    className="text-sm font-normal lg:font-medium leading-[17px] text-[#666666]"
                  >
                    Mode
                  </label>
                  <RadioGroup
                    className="w-full grid grid-cols-3 sm:grid-cols-2"
                    onValueChange={(value) => {
                      setValue("mode", value);
                    }}
                    value={watch("mode")}
                    aria-label="mode"
                    name="mode"
                    id="mode"
                  >
                    {educationPaymentModes.map((item) => (
                      <label
                        key={item.value}
                        htmlFor={item.label}
                        className={` ${
                          watch("mode") === item.value ? " border-blue-700" : " "
                        } flex w-full items-center rounded-lg border p-3 h-12 space-x-2`}
                      >
                        <RadioGroupItem
                          value={item.value}
                          id={item.label}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
                        />
                        <p className="text-sm font-normal lg:font-medium">{item.label}</p>
                      </label>
                    ))}
                  </RadioGroup>
                </div>
              )}
            </div>
            {watch("purpose") !== "3" &&
              watch("purpose") !== "4" &&
              watch("mode") !== "20" && (
                <div className="space-y-2 order-7">
                  {/* offer letter upload input */}
                  {!watch("offerletter_checked") && (
                    <>
                      <label className="text-[14px] font-normal text-[#000]">
                        Offer Letter
                      </label>
                      <div className="flex gap-2 flex-col">
                        <div
                          className={`py-1.5 px-3.5 justify-between rounded-md flex border ${
                            watch("offer_letter_file")
                              ? "bg-[#F2F7FF]"
                              : "bg-[#fff]"
                          }`}
                        >
                          <div className="flex gap-3 items-center overflow-hidden">
                            <Img src="/images/remit/file.svg" alt="" />
                            <p className="truncate font-normal text-sm">
                              {watch("offer_letter_file")?.name ||
                                "Upload offer letter"}
                            </p>
                          </div>
                          <label
                            htmlFor="offerLetterInput"
                            className="text-blue-700 disabled:opacity-40 border cursor-pointer border-blue-700 text-white ml-2 px-4 py-2 rounded-lg whitespace-nowrap"
                          >
                            Upload
                          </label>
                          <input
                            id="offerLetterInput"
                            type="file"
                            className="hidden disabled:opacity-40"
                            disabled={watch("offerletter_checked")}
                            onChange={(e) => {
                              const selectedFile = e.target.files?.[0];
                              if (selectedFile) {
                                if (selectedFile?.type === "application/pdf") {
                                  setValue("offer_letter_file", selectedFile);
                                } else {
                                  toast.error("Only PDF files are allowed.");
                                }
                              }
                            }}
                            accept="application/pdf"
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {/* check box */}
                  <div className="flex items-center gap-2 ">
                    <input
                      type="checkbox"
                      id="offerletterConfirm"
                      className="w-4 h-4 cursor-pointer disabled:opacity-40"
                      style={{ borderRadius: "5px" }}
                      checked={watch("offerletter_checked")}
                      onChange={(e) => {
                        setValue("offerletter_checked", e.target.checked);
                        if (e.target.checked) {
                          setValue("offer_letter_file", null);
                        } else {
                          setValue("amount", "");
                          setValue("country", "");
                        }
                      }}
                      placeholder="I do not have the offer letter"
                    />
                    <label
                      htmlFor="offerletterConfirm"
                      style={{
                        opacity: !!watch("offer_letter_file") ? "40%" : "100%",
                      }}
                      className="text-sm"
                    >
                      I do not have the offer letter.
                    </label>
                  </div>
                </div>
              )}
          </div>

          <div className="w-1/2 sm:w-full flex flex-col gap-4">
            {((watch("purpose") === "1" && watch("mode") === "20") ||
              watch("purpose") === "3" ||
              watch("purpose") === "4") &&
              !watch("cal_error") && (
                <section className="w-full bg-white-A700 py-1 lg:py-5 rounded-xl gap-4 flex flex-col">
                  <div className="pt-5 pb-10 px-0 lg:px-5 border-b-8 rounded-xl bg-custom-calc-gradient border-blue-700 gap-10">
                    <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                      <div className="flex flex-col gap-4 w-full">
                        <div className="flex justify-between w-full">
                          <span className="text-sm font-normal lg:font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                            Customer Rate
                          </span>
                          {isCalcLoading ? (
                            <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                          ) : (
                            <span className="text-sm font-semibold float-right leading-4 indent-3.5 text-[#333333]">
                              {!watch("cal_customer_rate")
                                ? "0.00"
                                : `INR ${watch("cal_customer_rate")}`}
                            </span>
                          )}
                        </div>
                        <div className="flex justify-between w-full">
                          <span className="text-sm font-normal lg:font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                            Receiving amount
                          </span>
                          {isCalcLoading ? (
                            <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                          ) : (
                            <span className="text-sm font-semibold float-right leading-4 indent-3.5 text-[#333333]">
                              {!watch("amount")
                                ? "0.00"
                                : (!watch("currency") || !watch("currency")
                                  ? "USD "
                                  : `${watch("currency")} `) +
                                formatIndianNumber(
                                  parseFloat(watch("amount"))?.toFixed(4)
                                ).toString()}
                            </span>
                          )}
                        </div>
                        <div className="w-full border-[.3px]" />
                        <div className="flex flex-col w-full gap-4">
                          <div className="flex justify-between w-full">
                            <span className="text-sm leading-[17px] indent-3.5 font-normal">
                              Total Charges
                            </span>
                            {isCalcLoading ? (
                              <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                            ) : (
                              <span className="text-sm font-semibold float-right leading-4 indent-3.5 text-[#333333]">
                                {!watch("cal_total_charges") || !watch("amount")
                                  ? "0.00"
                                  : `INR ${parseFloat(
                                    Number(watch("cal_total_charges"))?.toFixed(
                                      2
                                    )
                                  )}`}
                              </span>
                            )}
                          </div>
                          <div className="ml-4 border-l border-gray-300 flex flex-col gap-4 mt-2">
                            <div className="flex justify-between w-full mb-2">
                              <span className="text-sm font-normal lg:font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                                GST on FX conversion
                              </span>
                              {isCalcLoading ? (
                                <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                              ) : (
                                <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                                  {!watch("cal_gst") || !watch("amount")
                                    ? "0.00"
                                    : `INR ${Number(watch("cal_gst"))?.toFixed(
                                      2
                                    )}`}
                                </span>
                              )}
                            </div>
                            <div className="flex justify-between w-full mb-2">
                              <span className="text-sm font-normal lg:font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                                TCS
                              </span>
                              {isCalcLoading ? (
                                <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                              ) : (
                                <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                                  {!watch("tcs")
                                    ? "0.00"
                                    : `INR ${Number(watch("tcs"))?.toFixed(2)}`}
                                </span>
                              )}
                            </div>
                            <div className="flex justify-between w-full mb-2">
                              <span className="text-sm font-normal lg:font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                                Foreign Bank charges{" "}
                                <span className="text-sm font-normal lg:font-medium text-gray-500">
                                  (incl. GST)
                                </span>
                              </span>
                              {isCalcLoading ? (
                                <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                              ) : (
                                <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                                  {!watch("cal_foreign_bank_charges") ||
                                    !watch("amount")
                                    ? "0.00"
                                    : `INR ${Number(
                                      watch("cal_foreign_bank_charges")
                                    )?.toFixed(2)}`}
                                </span>
                              )}
                            </div>
                            <div className="flex justify-between w-full">
                              <span className="text-sm font-normal lg:font-medium leading-[14.5px] indent-3.5 text-[#666666]">
                                TT charges{" "}
                                <span className="text-sm font-normal lg:font-medium text-gray-500">
                                  (incl. GST)
                                </span>
                              </span>
                              {isCalcLoading ? (
                                <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                              ) : (
                                <span className="text-sm float-right leading-4 indent-3.5 text-[#333333]">
                                  {!watch("cal_tt_charges") || !watch("amount")
                                    ? "0.00"
                                    : `INR ${Number(
                                      watch("cal_tt_charges")
                                    )?.toFixed(2)}`}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between pt-2.5 text-blue-700 w-full">
                        <span className="text-md leading-[14.5px] indent-3.5 font-semibold">
                          Total estimation
                        </span>
                        {isCalcLoading ? (
                          <Skeleton className="h-4 bg-gray-600 w-[100px] rounded-full" />
                        ) : (
                          <span className=" font-normal lg:font-medium float-right leading-4 indent-3.5">
                            {!watch("cal_total_payable") || !watch("amount")
                              ? "0.00"
                              : `INR ${formatIndianNumber(
                                parseFloat(watch("cal_total_payable"))?.toFixed(
                                  2
                                )
                              )}`}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {(["4", "3"].includes(watch("purpose")) ||
                    (watch("purpose") === "1" && watch("mode") === "20")) && (
                      <div className="w-full">
                        <div className="w-full rounded-md flex items-center">
                          <div className="flex items-center justify-between w-full bg-[#F9F9F9] rounded-xl border-none py-0 pr-5  ">
                          <small className="font-base leading-4 -tracking-[1%] p-2.5 rounded-md text-[#666666] text-sm">
                            <Img src="/images/profit.png" alt="info" className=" w-5 h-5" />
                          </small>
                            <div className="flex items-center gap-1.5">
                              {showProfit ? (
                                <small className="font-base leading-4 -tracking-[1%] rounded-md text-[#666666] text-sm">
                                  INR{" "}
                                  {watch("cal_profit")
                                    ? watch("cal_profit")
                                    : "0.00"}
                                </small>
                              ) : (
                                <span className="text-sm font-semibold leading-4 text-blue-700">
                                  Click to view profit
                                </span>
                              )}
                              <button onClick={() => setShowProfit(!showProfit)}>
                                <svg
                                  width="22"
                                  height="16"
                                  viewBox="0 0 22 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M11 5C11.7956 5 12.5587 5.31607 13.1213 5.87868C13.6839 6.44129 14 7.20435 14 8C14 8.79565 13.6839 9.55871 13.1213 10.1213C12.5587 10.6839 11.7956 11 11 11C10.2044 11 9.44129 10.6839 8.87868 10.1213C8.31607 9.55871 8 8.79565 8 8C8 7.20435 8.31607 6.44129 8.87868 5.87868C9.44129 5.31607 10.2044 5 11 5ZM11 0.5C16 0.5 20.27 3.61 22 8C20.27 12.39 16 15.5 11 15.5C6 15.5 1.73 12.39 0 8C1.73 3.61 6 0.5 11 0.5ZM2.18 8C2.98825 9.65031 4.24331 11.0407 5.80248 12.0133C7.36165 12.9858 9.1624 13.5013 11 13.5013C12.8376 13.5013 14.6383 12.9858 16.1975 12.0133C17.7567 11.0407 19.0117 9.65031 19.82 8C19.0117 6.34969 17.7567 4.95925 16.1975 3.98675C14.6383 3.01424 12.8376 2.49868 11 2.49868C9.1624 2.49868 7.36165 3.01424 5.80248 3.98675C4.24331 4.95925 2.98825 6.34969 2.18 8Z"
                                    fill="#165FE3"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </section>
              )}
            <FormProvider {...methods}>
              <ContactAlert setPancard={setPancard} handleSubmit={() => { }}>
                <button
                  disabled={buttonState()}
                  className="bg-blue-700 py-4 disabled:opacity-40 disabled:cursor-not-allowed text-white-A700 font-semibold text-sm leading-5 rounded-lg w-full hover:bg-blue-800 transition duration-200 ease-in-out"
                >
                  {checkForFetch ? "Get Quote" : "Request Quote"}
                </button>
              </ContactAlert>
            </FormProvider>
          </div>
        </TabsContent>
      </Tabs>
    </section>
  );
}

interface AlertProps {
  children: React.ReactNode;
  handleSubmit?: () => void;
  setPancard?: (value:string) => void;
}

const ContactAlert = ({ children, setPancard }: AlertProps) => {
  const dispatch = useAppDispatch();
  const {L2PanCardDetails} = useAppSelector((state)=>state.PartnerRegistration)
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState<string | null>(null);
  // const [selectedNumber, setSelectedNumber] = useState<string | null>(null);
  const [isSelectedNumber, setISSelectedNumber] = useState(false);
  const [contactDetails, setContactDetails] = useState<any>(null);
  const [selectedContact, setSelectedContatcted] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [buttonType, setButtonType] = useState("download");

  const { watch, getValues, setValue, reset } = useFormContext();

  const fetchSearchResults = async () => {
    if (!inputValue) {
      return;
    }
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetSearchConatctForPrepareQuoteRequestType> =
      {
        headers: { Authorization: `Bearer ${authToken}` },
        params: {
          phone_number: inputValue,
        },
      };
    try {
      if (inputValue === "") return;
      const response = (await searchContactViaPhone(payload)) as any;
      if (response?.data?.length === 0) {
        setOptions(() => []);
        setShowDropdown(true);
        setSelectedNumber(null);
        return;
      }
      let newOptions: ContactData[];
      newOptions = response?.data?.map((item: any) => ({
        value: item?.id,
        label: item?.full_name,
        contactName: item?.full_name,
        contactPhone: item?.phone_number,
        email: item?.email,
        location: `${item?.address_id?.at(-1)?.City || ''}, ${item?.address_id?.at(-1)?.State || ''}, ${item?.address_id?.at(-1)?.country || ''}`,
      }));

      const startingWithInput = newOptions.filter((item) =>
        item.contactPhone.startsWith(inputValue)
      );
      const containingInput = newOptions.filter(
        (item) =>
          !item.contactPhone.startsWith(inputValue) &&
          item.contactPhone.includes(inputValue)
      );

      // Prioritize numbers that start with inputValue
      const sortedOptions = [...startingWithInput, ...containingInput];

      setShowDropdown(true);
      setOptions(sortedOptions);
    } catch (error: any) {
      if (error.response?.status === 429) {
        toast.error("Search limit exceeded.", {
          description:
            "You have exceeded the limit of requests. Please try again later.",
        });
      }
      toast.error("Error fetching options");
      setOptions([]);
      setShowDropdown(false);
      setSelectedNumber(null);
      setISSelectedNumber(false);
    }
  };

  const handleSubmit = async (
    type: string
  ): Promise<string | undefined | void> => {
    try {
      // Retrieve and validate the auth token
      const auth = localStorage.getItem("authToken");
      if (!auth) {
        console.error("No auth token found");
        return;
      }

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(
        2,
        "0"
      )}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(
        today.getFullYear()
      ).slice(-2)}`;

      const remit_qoute_data = {
        data: {
          date: formattedDate,
          customer_name: selectedContact?.contactName,
          customer_number: selectedContact?.contactPhone,
          purpose: watch("purpose") === "1" ? watch("mode") : watch("purpose"),
          currency: watch("currency"),
          remitter_send: `${formatIndianNumber(
            parseFloat(watch("cal_total_payable"))?.toFixed(2)
          )}`,
          beneficiary_received: `${
            watch("currency") || "USD"
          } ${formatIndianNumber(parseFloat(watch("amount"))?.toFixed(4))}`,
          customer_rate: watch("cal_customer_rate")
            ? ` ${watch("cal_customer_rate")}`
            : " 0.00",
          total_charges: ` ${Number(watch("cal_total_charges"))?.toFixed(2)}`,
          gst: ` ${Number(watch("cal_gst"))?.toFixed(2)}`,
          fb_charges: ` ${Number(watch("cal_foreign_bank_charges"))?.toFixed(
            2
          )}`,
          tt_charges: ` ${Number(watch("cal_tt_charges"))?.toFixed(2)}`,
          payable_amount: `${formatIndianNumber(
            parseFloat(watch("cal_total_payable"))?.toFixed(2)
          )}`,
          partner_name: "",
          tcs: getValues("tcs")
        },
      };

      const authToken = JSON.parse(auth);
      // make an array from watch('whatsapp') and watch('email') and make it leike ['whatsapp', 'email']
      const channelArray = [];
      if (watch("share_whatsapp")) {
        channelArray.push("whatsapp");
      }
      if (watch("share_email")) {
        channelArray.push("email");
      }
      let fileToUpload: string = "";
      if (watch("offer_letter_file")) {
        fileToUpload = await convertFileToBase64(watch("offer_letter_file"));
      }

      // Prepare the payload
      const payload: AxiosRequestConfig<QuoteFromHomePageRequestType> = {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          data: remit_qoute_data.data,
          contacts_id: selectedContact?.value,
          Name: getValues("name"),
          email: getValues("email"),
          number: inputValue,
          pancard: L2PanCardDetails,
          purpose_id:
            getValues("purpose") === "1"
              ? getValues("mode")
              : getValues("purpose"),
          channel: channelArray,
          country: getValues("country"),
          amount: getValues("amount"),
          document: fileToUpload
            ? [
                {
                  doc_list_id: 5,
                  doc: fileToUpload,
                },
              ]
            : [],
        },
      };
      // Set loading state and make the API call
      setLoading(true);
      const res = (await quoteFromHomePage(payload)) as any;
      if (res?.status === 200) {
        setLoading(false);
        setOpen(false);
        setInputValue("");
        setOptions([]);
        setButtonType("download");
        setShowDropdown(false);
        setSelectedNumber(null);
        setContactDetails(null);
        dispatch(setL2PanCardDetails(""))
        setISSelectedNumber(false);    
        setPancard?.("");    
        reset({
          name: "",
          email: "",
          amount: "",
          purpose: "1",
          mode: "20",
          country: "",
          currency: "INR",
          service_partner_id: "",
          offer_letter_file: null,
          offerletter_checked: false,
          share_whatsapp: false,
          share_email: false,
          fxCharges: "BEN",
          customer_rate: "",
          cal_customer_rate: "",
          pancard_no: "",
        });
        if (type === "download") {
          toast.success("Quote downloaded successfully");
          handleDownloadViaURL(res?.data);
        } else if (type === "request") {
          toast.success("Quote requested successfully");
        } else {
          toast.success("Quote shared successfully");
        }
      }
      // Handle the response
    } catch (err: any) {
      toast.error(err.message || "An error occurred");
      setLoading(false);
    } finally {
      setLoading(false); // Ensure loading is always turned off
    }
  };

  const handleSelectList = (
    option: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setInputValue(option.contactPhone?.replace("+", ""));
    setSelectedNumber(option.contactPhone);
    setContactDetails(option);
    setShowDropdown(false);
    setSelectedContatcted(option);
    setISSelectedNumber(true);
  };

  useDebounce(
    () => {
      if (inputValue.length >= 10) {
        fetchSearchResults();
      } else {
        setOptions([]);
        setShowDropdown(false);
        setSelectedNumber(null);
        setISSelectedNumber(false);
      }
    },
    600,
    [inputValue]
  );

  const avoidCalc = ["1", "3", "4"].includes(watch("purpose"));
  const checkForFetch = avoidCalc
    ? watch("purpose") === "1"
      ? watch("mode") === "20"
        ? true
        : false
      : true
    : false;
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger>{children}</AlertDialogTrigger>
      <AlertDialogPortal>
        {loading && <Spinner />}
        <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
        <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-md animate-contentShow gap-0">
          <AlertDialogHeader className="flex flex-row items-center justify-between text-left gap-4 pt-4 pb-4 px-10 border-b">
            <AlertDialogTitle className="font-bold text-xl leading-7 tracking-[2%] text-gray-900">
              {buttonType === "download" ? "Contact details" : "Share Quote"}
            </AlertDialogTitle>
            <X
              onClick={() => {
                if (buttonType === "share") {
                  setButtonType("download");
                  return;
                }
                setOpen(false);
                setInputValue("");
                setOptions([]);
                setShowDropdown(false);
                setSelectedNumber(null);
                setISSelectedNumber(false);
                setContactDetails(null);
                setValue("email", "");
                setValue("name", "");
                setValue("share_whatsapp", false);
                setValue("share_email", false);
              }}
              className="cursor-pointer !m-0"
              size={20}
              color="#165fe3"
            />
          </AlertDialogHeader>
          <form action="" className="px-10 py-[30px] space-y-4">
            {buttonType === "download" ? (
              <>
                <div className="space-y-2">
                  <label
                    htmlFor="amount"
                    className="text-sm font-medium leading-[17px] text-[#666666]"
                  >
                    Mobile number
                  </label>
                  <div className="relative w-full h-12 flex rounded-md">
                    <ComboBoxCurrency />
                    <Input
                      type="number"
                      onWheel={(e) => e.currentTarget.blur()}
                      placeholder="Enter the mobile number"
                      onChange={(e) => {
                        const value = e.target.value;
                        setInputValue(value);
                        if (value.trim() === "") {
                          setOptions([]);
                          setShowDropdown(false);
                          setSelectedNumber(null);
                          setISSelectedNumber(false);
                          setValue("email", "");
                          setValue("name", "");
                          setContactDetails(null);
                        }
                      }}
                      value={inputValue}
                      className="text-sm font-medium border border-black-label h-12 rounded-lg rounded-tl-none border-l-0 rounded-bl-none p-4 w-full"
                    />
                  </div>
                </div>
                {showDropdown && options?.length > 0 && (
                  <div
                    className={`${
                      showDropdown ? "block border" : "hidden"
                    } relative w-full bg-white  border-gray-300 rounded-md mt-1 shadow-lg max-h-48 overflow-y-auto`}
                  >
                    {options?.length > 0
                      ? options.map((option: any) => (
                          <button
                            key={option.value}
                            className="flex w-full justify-between items-center p-3 text-sm font-medium cursor-pointer hover:bg-gray-100"
                            onClick={(event) => handleSelectList(option, event)}
                          >
                            <span className="text-gray-600">
                              {option.contactPhone}
                            </span>
                            <span className="font-medium">
                              {option.contactName}
                            </span>
                          </button>
                        ))
                      : null}
                  </div>
                )}
              </>
            ) : (
              <div className="">
                <p className="">Share</p>
                <div className="bg-[#FAFAFA] flex gap-2 flex-col p-2 rounded-lg">
                  <label className="flex items-center gap-2" htmlFor="whatsapp">
                    <input
                      checked={watch("share_whatsapp")}
                      onChange={(e) => {
                        setValue("share_whatsapp", e.target.checked);
                      }}
                      type="checkbox"
                      name="whatsapp"
                      id="whatsapp"
                      className="rounded-[4px]"
                    />
                    <p className="flex justify-between w-full items-center">
                      Whatsapp
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8576_141444)">
                          <path
                            d="M0.345625 7.90159C0.34525 9.2459 0.69925 10.5585 1.37238 11.7155L0.28125 15.6685L4.35825 14.6078C5.4859 15.2169 6.74934 15.536 8.03325 15.5361H8.03663C12.2751 15.5361 15.7253 12.1139 15.7271 7.90761C15.7279 5.86934 14.9286 3.95269 13.4765 2.51071C12.0246 1.06885 10.0937 0.274368 8.03631 0.273438C3.79738 0.273438 0.347438 3.69545 0.345688 7.90159"
                            fill="url(#paint0_linear_8576_141444)"
                          />
                          <path
                            d="M0.066875 7.90177C0.0664375 9.29445 0.433125 10.654 1.13025 11.8524L0 15.9471L4.22319 14.8484C5.38681 15.4779 6.69694 15.8098 8.03006 15.8103H8.0335C12.424 15.8103 15.9981 12.265 16 7.90809C16.0007 5.79659 15.1727 3.81104 13.6687 2.3174C12.1646 0.823938 10.1646 0.000868217 8.0335 0C3.64225 0 0.068625 3.54481 0.066875 7.90177ZM2.58194 11.646L2.42425 11.3976C1.76137 10.3518 1.4115 9.14326 1.412 7.90226C1.41337 4.28087 4.38363 1.33457 8.036 1.33457C9.80475 1.33532 11.467 2.01947 12.7172 3.26078C13.9674 4.5022 14.6554 6.15243 14.6549 7.9076C14.6533 11.529 11.683 14.4757 8.0335 14.4757H8.03088C6.84256 14.475 5.67712 14.1584 4.66075 13.56L4.41888 13.4177L1.91275 14.0696L2.58194 11.646Z"
                            fill="url(#paint1_linear_8576_141444)"
                          />
                          <path
                            d="M6.04125 4.59977C5.89212 4.27091 5.73519 4.26427 5.59337 4.2585C5.47725 4.25354 5.3445 4.25391 5.21187 4.25391C5.07912 4.25391 4.86344 4.30346 4.68112 4.50098C4.49862 4.69869 3.98438 5.17646 3.98438 6.14818C3.98438 7.1199 4.69769 8.05906 4.79712 8.19097C4.89669 8.32263 6.17419 10.3805 8.19744 11.1722C9.87894 11.8302 10.2211 11.6993 10.5861 11.6663C10.9511 11.6334 11.7638 11.1887 11.9296 10.7275C12.0956 10.2663 12.0956 9.87103 12.0458 9.78842C11.9961 9.70613 11.8633 9.6567 11.6642 9.55797C11.4652 9.45925 10.4865 8.98135 10.3041 8.91543C10.1216 8.84957 9.98887 8.8167 9.85612 9.01447C9.72337 9.21193 9.34219 9.6567 9.226 9.78842C9.10994 9.92045 8.99375 9.93689 8.79475 9.8381C8.59556 9.739 7.9545 9.53069 7.19394 8.85788C6.60219 8.33435 6.20269 7.68783 6.08656 7.49007C5.97044 7.29261 6.07412 7.18557 6.17394 7.08715C6.26337 6.99866 6.37306 6.85652 6.47269 6.74123C6.57194 6.62588 6.60506 6.54359 6.67144 6.41187C6.73787 6.28002 6.70462 6.16467 6.65494 6.06588C6.60506 5.96709 6.21825 4.99028 6.04125 4.59977Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_8576_141444"
                            x1="772.572"
                            y1="1539.78"
                            x2="772.572"
                            y2="0.273438"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#1FAF38" />
                            <stop offset="1" stop-color="#60D669" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_8576_141444"
                            x1="800"
                            y1="1594.71"
                            x2="800"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#F9F9F9" />
                            <stop offset="1" stop-color="white" />
                          </linearGradient>
                          <clipPath id="clip0_8576_141444">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </p>
                  </label>
                  <label className="flex items-center gap-2" htmlFor="email">
                    <input
                      checked={watch("share_email")}
                      onChange={(e) => {
                        setValue("share_email", e.target.checked);
                      }}
                      type="checkbox"
                      name="email"
                      id="email"
                      disabled={!options?.length && !watch("email")}
                      className="rounded-[4px] disabled:cursor-not-allowed disabled:opacity-40 peer"
                    />
                    <p className="flex peer-disabled:opacity-40 peer-disabled:cursor-not-allowed  justify-between w-full items-center">
                      Email
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z"
                          fill="#F4F2ED"
                        />
                        <path
                          d="M2.60225 12.6907H4.59088V7.86109L1.75 5.73047V11.8384C1.75 12.31 2.13213 12.6907 2.60225 12.6907Z"
                          fill="#4285F4"
                        />
                        <path
                          d="M11.4062 12.6907H13.3949C13.8665 12.6907 14.2472 12.3086 14.2472 11.8385V5.73047L11.4062 7.86116"
                          fill="#34A853"
                        />
                        <path
                          d="M11.4062 4.16333V7.85652L14.2472 5.72589V4.58939C14.2472 3.53545 13.0441 2.93458 12.2017 3.5667"
                          fill="#FBBC04"
                        />
                        <path
                          d="M4.59375 7.86122V4.16809L8.00281 6.72478L11.4119 4.16797V7.86116L8.00281 10.418"
                          fill="#EA4335"
                        />
                        <path
                          d="M1.75 4.5972V5.73358L4.59088 7.86427V4.17114L3.79544 3.57452C2.95169 2.94239 1.75 3.54327 1.75 4.5972Z"
                          fill="#C5221F"
                        />
                      </svg>
                    </p>
                  </label>
                </div>
              </div>
            )}
            {selectedNumber && buttonType === "download" && (
              <div className="flex flex-col gap-3 w-full">
                <div className="bg-[#F9F9F9] rounded-xl p-2 flex flex-col gap-6 w-full">
                  <div className="flex flex-col gap-3 text-sm font-medium">
                    <div className="flex items-center gap-2.5">
                      <img
                        src="/images/createorder/profileIcon.svg"
                        alt="Remitter Name"
                        className="w-5 h-5"
                      />
                      <small className="text-gray-900 text-[14px] font-medium">
                        {selectedContact?.contactName}
                      </small>
                    </div>
                    <div className="flex text-sm font-medium flex-col gap-3">
                      <div className="flex items-center gap-2.5">
                        <img
                          src="/images/createorder/call.svg"
                          alt="Phone"
                          className="w-5 h-5"
                        />
                        <small className="text-gray-900 text-[14px] font-medium">
                          {selectedContact?.contactPhone !== ""
                            ? selectedContact?.contactPhone
                            : "NA"}
                        </small>
                      </div>
                      <div className="flex items-center gap-2.5">
                        <img
                          src="/images/createorder/sms.svg"
                          alt="Email"
                          className="w-5 h-5"
                        />
                        <small className="text-gray-900 text-[14px] font-medium">
                          {selectedContact?.email === ""
                            ? "NA"
                            : selectedContact?.email}
                        </small>
                      </div>
                    </div>
                    {
                      (selectedContact?.location as string)?.replace(/,/g, '').replace(/^\s+|\s+$/g, '') !== "" &&
                      <div className="flex items-center gap-2.5">
                        <img
                          src="/images/createorder/location.svg"
                          alt="Address"
                          className="w-5 h-5"
                        />
                        <small className="max-w-xs text-gray-900 text-[14px] font-medium">
                          {selectedContact?.location !== ""
                            ? selectedContact?.location
                            : "NA"}
                        </small>
                      </div>
                    }
                  </div>
                </div>
              </div>
            )}
            {!options?.length &&
              inputValue.length >= 10 &&
              buttonType !== "share" && (
                <>
                  <div className="relative space-y-2">
                    <label
                      htmlFor="amount"
                      className="text-sm font-medium leading-[17px] text-[#666666]"
                    >
                      Name
                    </label>
                    <Input
                      type="text"
                      id="name"
                      name="name"
                      value={watch("name")}
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue("name", value);
                      }}
                      placeholder="Enter name"
                      className="m-0 h-12 w-full border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
                    />
                  </div>
                  <div className="relative space-y-2">
                    <label
                      htmlFor="amount"
                      className="text-sm font-medium leading-[17px] text-[#666666]"
                    >
                      Email
                    </label>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={watch("email")}
                      onChange={(e) => {
                        const value = e.target.value;
                        setValue("email", value);
                      }}
                      placeholder="Enter email"
                      className="m-0 h-12 w-full border border-gray-border-gray-lite py-1.5 pr-[7px] rounded-lg"
                    />
                  </div>
                </>
              )}
          </form>
          <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
            {checkForFetch ? (
              buttonType === "download" ? (
                <>
                  <button
                    className="disabled:opacity-40 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                    onClick={() => {
                      handleSubmit("download");
                    }}
                    disabled={!contactDetails?.value && !watch("name")}
                  >
                    Download
                  </button>
                  <button
                    onClick={() => {
                      setButtonType("share");
                    }}
                    disabled={
                      !contactDetails?.value &&
                      !watch("name") &&
                      !watch("email")
                    }
                    className="rounded-lg disabled:opacity-40 border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                  >
                    Share Quote
                  </button>
                </>
              ) : (
                <div className="flex items-center justify-between w-full">
                  <button
                    onClick={() => {
                      setButtonType("download");
                    }}
                    className="py-[11px] px-4 text-blue-700"
                  >
                    Previous
                  </button>

                  <button
                    onClick={() => {
                      handleSubmit("share");
                    }}
                    disabled={!watch("share_whatsapp") && !watch("share_email")}
                    className="rounded-lg disabled:opacity-40 border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                  >
                    Share
                  </button>
                </div>
              )
            ) : (
              <button
                onClick={() => {
                  handleSubmit("request");
                }}
                disabled={
                  !contactDetails?.value && !watch("name") && !watch("email")
                }
                className="rounded-lg disabled:opacity-40 border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
              >
                Request quote
              </button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
};
